import { render, staticRenderFns } from "./autocomplete-product.vue?vue&type=template&id=3960a4eb&"
import script from "./autocomplete-product.vue?vue&type=script&lang=js&"
export * from "./autocomplete-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports